import dmAutomation from "./instagram-dm-automation";
import storyReply from "./instagram-story-reply-automation";
import commentToDm from "./instagram-comment-to-dm-automation";
import catalogCheckout from "./instagram-product-catalog-checkout";
import orderManagement from "./instagram-order-management";
import compare from "./compare";

// Order here is the order shown on the /features hub page.
export const FEATURES = [
  dmAutomation,
  commentToDm,
  storyReply,
  catalogCheckout,
  orderManagement,
  compare,
];

export function getFeature(slug) {
  return FEATURES.find((f) => f.slug === slug) || null;
}
